import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { datePipe, delayedFunctionCall } from '@piqet-angular/data';
import { reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-carbon-footprint-report',
  templateUrl: './carbon-footprint-report.component.html',
  styleUrls: ['./carbon-footprint-report.component.scss'],
})
export class CarbonFootprintReportComponent {
  profilePic = './assets/images/defaultProfile.jpg';
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  organizationImage = './assets/images/GlobalWarming.png';

  @Input() reportData: any;
  reportResource = reportTitals;
  mainProjectName!: string;
  remainingProjectName!: string;
  tableId = 3;
  interpretedText: any;
  lifeCycleStageContributionImpactItemsTableId: any;
  packagingLevelContributionImpactItemsTableId: any;
  componentContributionItemsTableId: any;
  ingredientContributionItemsTableId: any;
  transportContributionItemsTableId: any;
  lifeCycleStageContributionImpactItemsFigureId: any;
  packagingLevelContributionImpactItemsFigureId: any;
  componentContributionItemsFigureId: any;
  ingredientContributionItemsFigureId: any;
  transportContributionItemsFigureId: any;
  figureId = 1;
  @Output() checkContent = new EventEmitter<{ projectName: any }>();
  constructor(private sharedService: SharedService, private reportService: ReportsService) {}
  ngOnInit() {}
  ngAfterViewInit() {
    if (!!this.reportData && this.reportData.isExport) {
      this.checkContent.emit({ projectName: this.reportData.projectName });
    }
  }
  exportPdfFun() {
    if (!!this.reportData && this.reportData.isExport) {
      this.checkContent.emit({ projectName: this.reportData.projectName });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.reportData = changes['reportData'].currentValue;
    const projectInterpretation = this.reportData.spiderChartItems.projectInterpretation;
    this.interpretedText = !!projectInterpretation
      ? projectInterpretation.replace(/\n/g, '<br/>')
      : '';
    this.getRemainingText();
    this.setTableId();
    delayedFunctionCall(this.exportPdfFun, 3000, this);
  }

  setTableId() {
    this.lifeCycleStageContributionImpactItemsTableId = this.tableId;
    this.packagingLevelContributionImpactItemsTableId =
      this.lifeCycleStageContributionImpactItemsTableId +
      this.reportData.lifeCycleStageContributionImpactItems.length;
    this.componentContributionItemsTableId =
      this.packagingLevelContributionImpactItemsTableId +
      this.reportData.packagingLevelContributionImpactItems.length;
    this.ingredientContributionItemsTableId =
      this.componentContributionItemsTableId + this.reportData.componentContributionItems.length;
    this.transportContributionItemsTableId =
      this.ingredientContributionItemsTableId + this.reportData.ingredientContributionItems.length;

    this.lifeCycleStageContributionImpactItemsFigureId = this.figureId;
    this.packagingLevelContributionImpactItemsFigureId =
      this.lifeCycleStageContributionImpactItemsFigureId +
      this.reportData.lifeCycleStageContributionImpactItems.length;
    this.componentContributionItemsFigureId =
      this.packagingLevelContributionImpactItemsFigureId +
      this.reportData.packagingLevelContributionImpactItems.length;
    this.ingredientContributionItemsFigureId =
      this.componentContributionItemsFigureId + this.reportData.componentContributionItems.length;
    this.transportContributionItemsFigureId =
      this.ingredientContributionItemsFigureId + this.reportData.ingredientContributionItems.length;
  }
  getRemainingText(): string {
    const parts = this.reportData.projectName.split(' - ');
    this.mainProjectName = parts[0];
    if (parts.length > 1) {
      this.remainingProjectName = parts.slice(1).join(' - ');
    }
    return '';
  }

  getFormateDate(date: any) {
    return datePipe(date);
  }
}
